import { orange } from '@/theme/colors'
import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
`

export const TitleInput = styled.input`
	width: calc(100% + 1.2rem);
	margin-left: -0.6rem;
	margin-right: -0.6rem;
	font-size: 1.25rem;
	font-weight: 700;
	color: #111827;
	border: 1px solid transparent;
	border-radius: 6px;
	padding: 0.5rem 0.6rem;
	background: transparent;
	transition: all 0.15s ease;

	&:hover {
		background: #f3f4f6;
	}

	&:focus {
		outline: none;
		border-color: ${orange};
		background: #ffffff;
		box-shadow: 0 0 0 3px rgba(209, 95, 42, 0.15);
	}
`

export const FieldRow = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.45rem;
`

export const FieldHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`

export const FieldLabel = styled.label`
	font-size: 0.8rem;
	font-weight: 600;
	color: #374151;
	display: inline-flex;
	align-items: center;
	gap: 0.4rem;

	svg {
		width: 14px;
		height: 14px;
		fill: currentColor;
	}
`

export const EditButton = styled.button`
	background: #f3f4f6;
	color: #374151;
	border: 1px solid transparent;
	border-radius: 6px;
	padding: 0.3rem 0.7rem;
	font-size: 0.78rem;
	font-weight: 500;
	cursor: pointer;
	transition: background 0.15s ease;

	&:hover {
		background: #e5e7eb;
	}
`

export const FieldValue = styled.div`
	font-size: 0.9rem;
	color: #111827;
	line-height: 1.55;
	white-space: pre-wrap;
	word-break: break-word;
	padding: 0.45rem 0.5rem;
	margin: 0 -0.5rem;
	border-radius: 6px;
	background: transparent;
`

export const EmptyValue = styled(FieldValue)`
	color: #9ca3af;
	font-style: italic;
`

export const Textarea = styled.textarea`
	width: 100%;
	padding: 0.6rem 0.7rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 0.9rem;
	font-family: inherit;
	resize: vertical;
	min-height: 90px;

	&:focus {
		outline: none;
		border-color: ${orange};
		box-shadow: 0 0 0 3px rgba(209, 95, 42, 0.15);
	}
`

export const Select = styled.select`
	width: 100%;
	padding: 0.55rem 2.25rem 0.55rem 0.7rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 0.9rem;
	background-color: white;
	cursor: pointer;
	appearance: none;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23374151' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: right 0.85rem center;

	&:focus {
		outline: none;
		border-color: ${orange};
		box-shadow: 0 0 0 3px rgba(209, 95, 42, 0.15);
	}
`

export const ButtonRow = styled.div`
	display: flex;
	gap: 0.5rem;
	justify-content: flex-end;
`

export const PrimaryButton = styled.button`
	background: ${orange};
	color: white;
	border: none;
	border-radius: 6px;
	padding: 0.45rem 0.95rem;
	font-size: 0.85rem;
	font-weight: 500;
	cursor: pointer;
	transition: opacity 0.15s ease;

	&:hover:not(:disabled) {
		opacity: 0.9;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`

export const SecondaryButton = styled.button`
	background: white;
	color: #374151;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	padding: 0.45rem 0.95rem;
	font-size: 0.85rem;
	font-weight: 500;
	cursor: pointer;
	transition: background 0.15s ease;

	&:hover {
		background: #f3f4f6;
	}
`

export const LinkInputWrapper = styled.div`
	display: flex;
	gap: 0.4rem;
	margin-bottom: 0.4rem;
`

export const LinkTextInput = styled.input`
	flex: 1;
	padding: 0.5rem 0.7rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 0.85rem;

	&:focus {
		outline: none;
		border-color: ${orange};
		box-shadow: 0 0 0 3px rgba(209, 95, 42, 0.15);
	}
`

export const RemoveLinkBtn = styled.button`
	background: #ef4444;
	color: white;
	border: none;
	border-radius: 6px;
	padding: 0 0.6rem;
	cursor: pointer;
	font-size: 0.8rem;

	&:hover {
		background: #dc2626;
	}
`

export const AddLinkBtn = styled.button`
	background: white;
	color: #374151;
	border: 1px dashed #d1d5db;
	border-radius: 6px;
	padding: 0.5rem 0.9rem;
	font-size: 0.85rem;
	cursor: pointer;
	width: 100%;

	&:hover {
		background: #f9fafb;
	}
`

export const LinkListReadOnly = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`

export const LinkPreview = styled.a`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px;
	border: 1px solid #e5e7eb;
	border-radius: 6px;
	background: #f9fafb;
	text-decoration: none;
	transition: all 0.15s;
	overflow: hidden;
	min-width: 0;

	&:hover {
		background: #f3f4f6;
		border-color: ${orange};
	}
`

export const StaticLinkPreview = styled(LinkPreview)`
	cursor: default;
`

export const LinkThumbnail = styled.div<{ $src?: string }>`
	width: 96px;
	height: 72px;
	min-width: 96px;
	border-radius: 6px;
	background: ${props => (props.$src ? `url(${props.$src})` : '#e5e7eb')};
	background-size: cover;
	background-position: center;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	flex-shrink: 0;
`

export const LinkInfo = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 2px;
`

export const LinkSource = styled.div<{ $color?: string }>`
	font-size: 0.7rem;
	font-weight: 600;
	color: ${({ $color }) => $color ?? '#6b7280'};
	text-transform: capitalize;
`

export const LinkUrl = styled.div`
	font-size: 0.78rem;
	color: #3b82f6;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const LocationDisplay = styled.a`
	display: inline-flex;
	align-items: center;
	gap: 0.35rem;
	color: ${orange};
	text-decoration: none;
	font-size: 0.9rem;
	padding: 0.45rem 0.5rem;
	margin: 0 -0.5rem;
	width: fit-content;

	&:hover {
		text-decoration: underline;
	}
`

export const LocationSecondary = styled.div`
	font-size: 0.78rem;
	color: #6b7280;
	margin-top: 0.25rem;
`
